module.exports = __webpack_public_path__ + "img/exemplu-poza-slider-desktop.56aaa574.jpg";